export class User {
    public password = null;
}
